import React from "react";
import { useMediaQuery, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import DesktopHeader from "./DesktopHeader/DesktopHeader";
import MobileHeader from "./MobileHeader/MobileHeader";
import CheckoutHeader from "../../views/Checkout/components/CheckoutHeader/CheckoutHeader";

// Define the props type for Header
interface HeaderProps {
  toggleMiniCart: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleMiniCart }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/checkout") {
    return (
      <Box>
        <CheckoutHeader />
      </Box>
    );
  }

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="1000"
      role="banner"
      aria-label="Encabezado principal de Evefant"
    >
      {isMobile ? (
        <MobileHeader toggleMiniCart={toggleMiniCart} />
      ) : (
        <DesktopHeader toggleMiniCart={toggleMiniCart} />
      )}
    </Box>
  );
};

export default Header;
